module.exports = __webpack_public_path__ + "img/pIndex-t-slide1.2a1ed99b.jpg";